import { BeneficiaryType } from '@/types/customer';
import { VerificationResult, VerificationStatus } from '@/types/customerKYXVerification';

export interface GetCustomerKYXVerificationsFilters {
  readonly type?: BeneficiaryType;
  readonly name?: string;
  readonly verificationStatus?: VerificationStatus;
  readonly verificationResult?: VerificationResult;
  readonly fromDate?: string;
  readonly toDate?: string;
  readonly page: number;
  readonly size: number;
  readonly sort: readonly string[] | string;
}

export class GetCustomerKYXVerificationsFilters {
  public static initial(): GetCustomerKYXVerificationsFilters {
    return {
      page: 1,
      size: 10,
      sort: ['createdDate,desc'],
    };
  }
}
